import { render, staticRenderFns } from "./his-jianyan.vue?vue&type=template&id=43dc1a66&scoped=true&"
import script from "./his-jianyan.vue?vue&type=script&lang=ts&"
export * from "./his-jianyan.vue?vue&type=script&lang=ts&"
import style0 from "./his-jianyan.vue?vue&type=style&index=0&id=43dc1a66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc1a66",
  null
  
)

export default component.exports